export default __webpack_public_path__ + "static/media/illustration-recruit-4-w@2x.e506aba1.webp";